import { TinyEmitter } from 'tiny-emitter'

let bus = new TinyEmitter()

export default bus
